import {WorldRegularIcon} from 'shells/icon/svg/world-regular-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import styles from './domain-info.module.css';

interface Props {
    emailAddress: string | undefined;
    domain: string;
}

export function DomainInfo(props: Props) {
    return (
        <div className='pad-8'>
            <Stack spacing={16} alignItems='center'>
                <Body color='light' size='small'>
                    Domain of {props.emailAddress}
                </Body>
                <div className='flex align-center gap-8'>
                    <div className={styles['icon-container']}>
                        <WorldRegularIcon size={20} wrapWithDiv={false} />
                    </div>
                    <Body isBold={true} color='dark'>
                        {props.domain}
                    </Body>
                </div>
            </Stack>
        </div>
    );
}
